import { Pipe, PipeTransform } from '@angular/core';
import { formatTimeNumber } from 'server/shared/helpers/time';

@Pipe({
  name: 'formatMilitaryTimeNumber',
})
export class FormatMilitaryTimeNumberPipe implements PipeTransform {
  transform(time?: number): string {
    if (!time) return '';
    return formatTimeNumber(time);
  }
}
